const colors = {
    link: '#542376',
    linkHover: '#8032B6',
    linkDisable: '#a5a4a4',
    iconColor: '#46bc98',
    iconHover: '#542376',
    button: '#46BC98',
    default: '#46BC98',
};

const containerHeader = {
    header: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'baseline',
        alignContent: 'stretch',
        flexWrap: 'wrap',
        marginTop: -20,
        marginBottom: 17,
    },

    button: {
        marginTop: 40,
        height: 36,
        width: 236,
    },
};

const formElement = {
    label: {
        fontSize: 16,
        height: 18,
        lineHeight: 1.5,
        color: '#777',
        top: 36,
    },
    underLineStyle: {
        borderColor: '#e0e0e0',
        bottom: 7,
    },
    textField: {
        marginBottom: 8,
    },
    textFieldInput: {
        fontSize: 14,
    },
    divider: {
        backgroundColor: '#e0e0e0',
    },
    small: {
        fontSize: 12,
        color: '#777',
    },
    smallTitle: {
        fontSize: 12,
        color: '#777',
        display: 'block',
        marginBottom: 16,
    },
};

const paperStyle = {
    mainItem: {
        width: '100%',
        paddingTop: 16,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.2)',
    },
};

export const styles = {
    twinPanes: {
        wrapper: {
            minHeight: 'calc(100vh - 125px)',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'stretch',
        },

        headerStyle: {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'baseline',
            alignContent: 'stretch',
            marginTop: -22,
        },

        containerStyle: {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            paddingBottom: 30,
        },

        leftPaperStyle: {
            paddingTop: 22,
            paddingLeft: 20,
            paddingRight: 20,
            minHeight: '100vh',
            width: '50%',
            maxWidth: '50%',
            flexGrow: 1,
        },

        rightPaperStyle: {
            marginLeft: 34,
            paddingLeft: 16,
            paddingRight: 16,
            width: '50%',
            maxWidth: '50%',
            minHeight: '100vh',
            flexGrow: 1,
        },

        headerTitle: {
            flexGrow: 1,
        },
    },

    sidebar: {
        default: {
            width: '403px',
            marginLeft: '30px',
            marginRight: '14px',
            display: 'flex',
            flexDirection: 'column',
        },
        selectField: {
            marginTop: -18,
            fontSize: 14,
            width: 273,
        },
        button: {
            color: 'white',
            width: '100%',
            backgroundColor: '#46bc98',
            marginTop: 40,
            marginBottom: '4px',
            height: 36,
        },
    },

    headerTitle: {
        flexGrow: 0,
        fontSize: 24,
        fontWeight: 'normal',
        margin: '21px 0',
    },

    headerButton: {
        alignSelf: 'center',
        color: colors.link,
        marginRight: -17,
        marginLeft: 17,
    },

    list: {
        wrapperItem: {
            margin: '33px 0 35px',
            display: 'block',
        },
        default: {
            margin: 0,
            padding: 0,
            fontSize: 14,
        },
        primaryText: {
            paddingBottom: 4,
        },
    },
};

export { colors, containerHeader, formElement, paperStyle };



// WEBPACK FOOTER //
// src/lib/styles.js